export default "__VITE_ASSET__Cv9IJA1g__"